var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-pagination d-flex mx-n3 pt-5 justify-content-center"},[(_vm.articles.length === _vm.parameters.limit)?_c('button',{staticClass:"btn btn-outline-light rounded-pill pl-4 pr-3 mx-3",on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v(" Ver Mais "),_c('i',{staticClass:"icon-chevron-right lead"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }